import { render, staticRenderFns } from "./Wix.vue?vue&type=template&id=7c1d5dee&"
import script from "./Wix.vue?vue&type=script&lang=ts&"
export * from "./Wix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports